import React, { Fragment } from 'react';
import { Intro, MultipleChoice, Voiceover } from "cvs-core"
import image from '../../assets/images/pre-test@2x.png';


const vo = {

};

const data = [
  {
    inputType: 'radio',
    question: 'E-cigarettes are mostly just flavored water.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      }
    ]
  },
  {
    inputType: 'radio',
    question: 'Vaping is harmless.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      }
    ]
  },
  {
    inputType: 'radio',
    question: 'You can get addicted to nicotine by vaping.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      }
    ]
  },
  {
    inputType: 'radio',
    question: 'Both buying and using e-cigarettes is illegal for anyone under the age of 21.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      }
    ]
  },
];

const correctInput = {
  [data[0].question]: 'False',
  [data[1].question]: 'False',
  [data[2].question]: 'True',
  [data[3].question]: 'True'
};

const feedback = {
  success: {
    title: 'Nice job!',
    body: 'You know some of the truth and consequences of vaping and e-cigarette use.  Watch the videos to learn more about how vaping affects your physical health, mental health and overall well-being.'
  },
  error: {
    title: 'Almost!',
    body: 'Misperceptions of vaping are everywhere. Watch the videos to debunk commons myths around vaping and' +
      ' e-cigarette use.'
  },
  retry: {
    title: 'Almost!',
    body: 'Misperceptions of vaping are everywhere. Watch the videos to debunk commons myths around vaping and' +
      ' e-cigarette use.'
  }
}

export default {
  title: 'Pre Quiz One',
  path: '/pre-quiz/pre-quiz-one',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="What Do You Think?"
        lead='Before we begin, read the following statements and select whether you believe each statement is TRUE or FALSE.'
        direction='Select the best answer.'
        img={image}
      />
      <MultipleChoice
        data={data}
        feedback={feedback}
        correctInput={correctInput}
        
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/Pre-Quiz/preQuizOne.js